export const EXPORT_CALL = "EXPORT_CALL";

export function callExport(exportData, moduleName, fileName, messageFunction) {
  return { type: EXPORT_CALL, payload: { exportData, moduleName, fileName, messageFunction } };
}
